export type PageConfig = {
  stepSelector: string;
  nextUrl?: string;
  afterCodeStep?: number;
  afterBranchStep?: number;
  hasBranchQuestion?: boolean;
  isShortFlow?: boolean;
};

const PAGE_URL: Record<string, string> = {
  intro: './shadowzone.html',
  shadowzone: './neozone.html',
  neozone: './openzone.html',
  openzone: './herozone.html',
  herozone: './final.html',
};

export function getPageConfig(page: string): PageConfig {
  if (page === 'intro') {
    return {
      stepSelector: '#stepIntroContainer, #prizes, #form, #tutorial, #zoneIntro',
      nextUrl: PAGE_URL[page],
    };
  }

  if (page === 'shadowzone') {
    return {
      stepSelector: '#stepNeoZoneContainer, #question, #zoneIntro',
      nextUrl: PAGE_URL[page],
      afterCodeStep: 1,
      isShortFlow: true,
    };
  }

  if (page === 'neozone') {
    return {
      stepSelector: '#stepNeoZoneContainer, #question, #question-2, #question-3, #zoneIntro',
      nextUrl: PAGE_URL[page],
      afterCodeStep: 1,
      afterBranchStep: 2,
      hasBranchQuestion: true,
    };
  }

  if (page === 'openzone') {
    return {
      stepSelector: '#stepNeoZoneContainer, #question, #question-3, #zoneIntro',
      nextUrl: PAGE_URL[page],
      afterCodeStep: 1,
      // afterBranchStep: 2,
      // hasBranchQuestion: true,
    };
  }

  if (page === 'herozone') {
    return {
      stepSelector: '#stepNeoZoneContainer, #zoneIntro',
      nextUrl: PAGE_URL[page],
      afterCodeStep: 1,
      // isShortFlow: true,
    };
  }

  if (page === 'final') {
    return {
      stepSelector: '#experienceSurvey, #experienceCode',
    };
  }

  return {
    stepSelector: '#stepIntroContainer, #prizes, #form, #tutorial, #zoneIntro',
    nextUrl: PAGE_URL.intro,
  };
}